<template>
  <div class="templateWrapper">
    <div class="header">
      <span>Nitrogen Risk Assessment</span>
    </div>
    <div ref="resizableBox" style="width: 800px; height: 600px; margin: auto;">
        <l-map ref="map" :zoom="zoom" :center="center" @click="mapClicked">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker ref="mapMarker" :lat-lng="marker" :draggable=true @click="markerClicked" @dragend="markerDragEnd"></l-marker>
        </l-map>
        <div v-if="showGoButton" class="go-button-container">
          <div :class="goColClass"><button :class="goButtonClass" @mousedown="checkButtonMouseDown" @click="doRiskCheck">{{buttonText}}<span v-if="buttonPopout"><object type="image/svg+xml"  :data="require('../assets/hamburger.svg')"></object></span></button><span v-if="resultText" class="resultText">{{resultText}}</span></div>
        </div>
        <div v-if="showExtra" class="extra-info-box-wrapper" v-on:click="extraBoxWrapperClicked"><div class="extra-info-box"><ul>
          <li v-for="(value, key) in extraText" v-bind:key="key">
            <b>{{key}}:</b>&nbsp;{{value}}
          </li>
        </ul></div></div>
    </div>
  </div>
</template>

<script>

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import L from 'leaflet'
export default {
  name: 'Main',
  components: {LMap, LTileLayer, LMarker},
  data () {
    return {
      dummyBackend: false,
      zoom: 8,
      showGoButton: false,
      goColClass: ['column', 'gray'],
      goButtonClass: ['button', 'gray'],
      buttonText: 'RUN',
      resultText: false,
      buttonPopout: false,
      showExtra: false,
      extraText: {},
      riskCheckUrlPath: 'esoil.io/nrisk',
      currentLat: -37.121,
      currentLng: 144.86,
      center: L.latLng(-37.121, 144.86),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      marker: L.latLng(-37.121, 144.86)
    }
  },
  computed: {
    riskCheckUrl () {
      if (location.protocol === 'https:') {
        return 'https://' + this.riskCheckUrlPath
      } else {
        return 'http://' + this.riskCheckUrlPath
      }
    }
  },
  mounted () {
    this.$refs.resizableBox.style.width = '' + window.innerWidth + 'px'
    this.$refs.resizableBox.style.height = '' + (window.innerHeight - 32) + 'px'
    this.$refs.map.mapObject.invalidateSize()
    // recentre after change size;
    this.center = L.latLng(-37.121, 144.86)
    let self = this
    let onLocated = function (coordinates) {
      self.lat = coordinates.lat
      self.lng = coordinates.lng
      self.center = L.latLng(self.lat, self.lng)
      self.marker = L.latLng(self.lat, self.lng)
      self.resetButton(true)
    }
    let p1 = this.$getLocation()
    p1.then(onLocated, function (exc1) {
      window.setTimeout(function () {
        self.$getLocation().then(onLocated, function (exc2) {
          console.log(exc2)
        })
      }, 1)
    })
  },
  methods: {
    dummyBackendGetResult (lat, long) {
      return Math.random() * 50.0
    },
    applyResult (result, other) {
      let res = parseFloat(result)
      this.buttonText = res.toFixed(3)
      this.buttonPopout = true
      this.extraText = {}
      if (typeof other !== 'undefined' && other) {
        if (typeof other['Location'] !== 'undefined' && other['Location']) {
          this.extraText['Location'] = other['Location']
        }
        if (typeof other['Soil Moisture'] !== 'undefined' && other['Soil Moisture']) {
          this.extraText['Soil Moisture'] = parseFloat(other['Soil Moisture']).toFixed(4)
        }
        if (typeof other['nloss'] !== 'undefined' && other['nloss']) {
          this.extraText['N-loss'] = parseFloat(other['nloss']).toFixed(4)
        }
        if (typeof other['rain'] !== 'undefined' && other['rain']) {
          this.extraText['Rain'] = parseFloat(other['rain']).toFixed(1) + 'mm'
        }
        if (typeof other['soiltype'] !== 'undefined' && other['soiltype']) {
          this.extraText['Soil Type'] = other['soiltype']
        }
      }
      if (res > 30.0) { // red
        this.goButtonClass = ['button', 'red']
        this.goColClass = ['column', 'red']

        // this.resultText = 'BAD'
      } else if (res >= 15.0) { // yellow
        this.goButtonClass = ['button', 'brown']
        this.goColClass = ['column', 'brown']
        // this.resultText = 'MODERATE'
      } else { // green
        this.goButtonClass = ['button', 'green']
        this.goColClass = ['column', 'green']
        // this.resultText = 'GOOD'
      }
    },
    resetButton (show) {
      this.goButtonClass = ['button', 'gray']
      this.goColClass = ['column', 'gray']
      this.buttonText = 'RUN'
      this.resultText = false
      this.showGoButton = show
      this.buttonPopout = false
      this.showExtra = false
      this.extraText = {}
    },
    checkButtonMouseDown (ev) {
      if (this.buttonPopout) {
        ev.stopPropagation()
        ev.preventDefault()
        return false
      }
    },
    doRiskCheck (ev) {
      if (this.buttonPopout) {
        ev.stopPropagation()
        ev.preventDefault()
        this.showExtra = true
      }
      let axios = window.axios
      if (this.dummyBackend) {
        let result = this.dummyBackendGetResult(this.lat, this.lng)
        this.applyResult(result)
      } else {
        let self = this
        axios.get(this.riskCheckUrl, { params: { lat: this.lat, long: this.lng } })
          .then(function (response) {
            console.debug(response)
            let data = response.data
            let nloss = data['nloss']
            return self.applyResult(nloss, data)
          })
          .catch(function (error) {
            return console.log(error)
          })
      }
    },
    extraBoxWrapperClicked () {
      this.showExtra = false
    },
    mapClicked (ev) {
      if (ev.originalEvent.target === this.$refs.mapMarker.$el) {
        // console.debug('Marker clicked')
        return
      }
      // console.debug('Map clicked')
      let latlng = ev.latlng
      this.lat = latlng.lat
      this.lng = latlng.lng
      this.marker = L.latLng(this.lat, this.lng)
      this.resetButton(true)
    },
    markerClicked (ev) {
      // console.debug('Marker clicked.')

    },
    markerDragEnd (ev) {
      // console.debug('Marker dragEnd.')
      let latlng = ev.target.getLatLng()
      this.lat = latlng.lat
      this.lng = latlng.lng
      this.resetButton(true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.header {
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  background: white;
  z-index: 801;
  height: 32px;
  box-shadow: 0px 2px 10px 1px;
}

.header span {
  margin: auto auto;
  font-size: 26px;
}
.go-button-container {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background: white;
  z-index: 801;
}
.extra-info-box-wrapper {
  position: absolute;
  background: transparent;
  margin: 0px;
  padding: 0px;
  z-index: 802;
  width:100%;
  height: 100%;
  bottom: 0px;
}
.extra-info-box {
  position: relative;
  top: 50%;
  margin: auto auto;
  width: 220px;
  background: white;
  z-index: 803;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px;
}

.resultText {
  font-size: 1.5em;
}

.column {
  position: relative;
  z-index: 1;
  float: left;
  width: 100%;
  padding: 20px 0;
  text-align: center;
  white-space: nowrap;
}

.column .button + .button {
  margin-left: 20px;
}

.button {
  display: inline-block;
  position: relative;
  height: 34px;
  line-height: 17px;
  padding: 0 15px;
  font-size: 15px;
  font-weight: bold;
  color: white;
  text-decoration: none;
  text-shadow: 0 -1px rgba(0, 0, 0, 0.3);
  border: 2px solid;
  border-radius: 7px;
  outline: 0;
  -webkit-box-shadow: 0 2px 1px rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.25);
}

.button span {
  width: 25px;
  height: 25px;
}

.button span object {
  width: 25px;
  margin-left: 6px;
  margin-right:0px;
  fill: #ffffff !important;
  stroke: #ffffff !important;
  filter: drop-shadow( -0px -1px 0px rgba(0, 0, 0, 0.3) );
  vertical-align: text-bottom;
}

.button:before, .button:after {
  content: '';
  position: absolute;
}

.button:before {
  top: -5px;
  bottom: -5px;
  left: -5px;
  right: -5px;
  z-index: -1;
  border-radius: 9px;
}

.button:after {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-bottom: 0;
  border-radius: 7px;
}

.button.alt {
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.button.alt:before {
  display: none;
}

.column.gray {
  background: #9e9e9e;
}

.button.gray {
  background: #999999;
  border-color: #787878 #757575 #666666;
  background-image: -webkit-linear-gradient(top, #adadad 0%, #a6a6a6 50%, #999999 50%, #8e7b7c 100%);
  background-image: -moz-linear-gradient(top, #adadad 0%, #a6a6a6 50%, #999999 50%, #8e7b7c 100%);
  background-image: -o-linear-gradient(top, #adadad 0%, #a6a6a6 50%, #999999 50%, #8e7b7c 100%);
  background-image: linear-gradient(to bottom, #adadad 0%, #a6a6a6 50%, #999999 50%, #8e7b7c 100%);
}

.button.gray:before {
  background: #b6afaf;
  background-image: -webkit-linear-gradient(top, #8b8484, #c2b7b7);
  background-image: -moz-linear-gradient(top, #8b8484, #c2b7b7);
  background-image: -o-linear-gradient(top, #8b8484, #c2b7b7);
  background-image: linear-gradient(to bottom, #8b8484, #c2b7b7);
}

.button.gray:active {
  background: #a6a6a6;
  background-image: -webkit-linear-gradient(top, #8a7577 0%, #a1a1a1 60%, #a6a6a6 100%);
  background-image: -moz-linear-gradient(top, #8a7577 0%, #a1a1a1 60%, #a6a6a6 100%);
  background-image: -o-linear-gradient(top, #8a7577 0%, #a1a1a1 60%, #a6a6a6 100%);
  background-image: linear-gradient(to bottom, #8a7577 0%, #a1a1a1 60%, #a6a6a6 100%);
}

.button.gray:active:after {
  border-color: #a6a6a6;
}

.column.green {
  background: #429538;
}

.button.green {
  background: #3e952d;
  border-color: #29621e #275e1c #1d4715;
  background-image: -webkit-linear-gradient(top, #45b436 0%, #3ca933 50%, #3e952d 50%, #337c1d 100%);
  background-image: -moz-linear-gradient(top, #45b436 0%, #3ca933 50%, #3e952d 50%, #337c1d 100%);
  background-image: -o-linear-gradient(top, #45b436 0%, #3ca933 50%, #3e952d 50%, #337c1d 100%);
  background-image: linear-gradient(to bottom, #45b436 0%, #3ca933 50%, #3e952d 50%, #337c1d 100%);
}

.button.green:before {
  background: #4ac233;
  background-image: -webkit-linear-gradient(top, #317c22, #52d039);
  background-image: -moz-linear-gradient(top, #317c22, #52d039);
  background-image: -o-linear-gradient(top, #317c22, #52d039);
  background-image: linear-gradient(to bottom, #317c22, #52d039);
}

.button.green:active {
  background: #42a933;
  background-image: -webkit-linear-gradient(top, #31741b 0%, #3fa131 60%, #42a933 100%);
  background-image: -moz-linear-gradient(top, #31741b 0%, #3fa131 60%, #42a933 100%);
  background-image: -o-linear-gradient(top, #31741b 0%, #3fa131 60%, #42a933 100%);
  background-image: linear-gradient(to bottom, #31741b 0%, #3fa131 60%, #42a933 100%);
}

.button.green:active:after {
  border-color: #42a933;
}

.column.brown {
  background: #c5aa3b;
}

.button.brown {
  background: #c8a22e;
  border-color: #927622 #8e7321 #755f1b;
  background-image: -webkit-linear-gradient(top, #d5ba4a 0%, #d2ba3d 50%, #c8a22e 50%, #af821e 100%);
  background-image: -moz-linear-gradient(top, #d5ba4a 0%, #d2ba3d 50%, #c8a22e 50%, #af821e 100%);
  background-image: -o-linear-gradient(top, #d5ba4a 0%, #d2ba3d 50%, #c8a22e 50%, #af821e 100%);
  background-image: linear-gradient(to bottom, #d5ba4a 0%, #d2ba3d 50%, #c8a22e 50%, #af821e 100%);
}

.button.brown:before {
  background: #dcb94d;
  background-image: -webkit-linear-gradient(top, #ae8c24, #e3c15b);
  background-image: -moz-linear-gradient(top, #ae8c24, #e3c15b);
  background-image: -o-linear-gradient(top, #ae8c24, #e3c15b);
  background-image: linear-gradient(to bottom, #ae8c24, #e3c15b);
}

.button.brown:active {
  background: #d2b33d;
  background-image: -webkit-linear-gradient(top, #a6791d 0%, #d0af35 60%, #d2b33d 100%);
  background-image: -moz-linear-gradient(top, #a6791d 0%, #d0af35 60%, #d2b33d 100%);
  background-image: -o-linear-gradient(top, #a6791d 0%, #d0af35 60%, #d2b33d 100%);
  background-image: linear-gradient(to bottom, #a6791d 0%, #d0af35 60%, #d2b33d 100%);
}

.button.brown:active:after {
  border-color: #d2b33d;
}
.column.red {
  background: #d04022;
}

.button.red {
  background: #d02e17;
  border-color: #942110 #902010 #741a0d;
  background-image: -webkit-linear-gradient(top, #e74a29 0%, #e6451b 50%, #d02e17 50%, #b3150b 100%);
  background-image: -moz-linear-gradient(top, #e74a29 0%, #e6451b 50%, #d02e17 50%, #b3150b 100%);
  background-image: -o-linear-gradient(top, #e74a29 0%, #e6451b 50%, #d02e17 50%, #b3150b 100%);
  background-image: linear-gradient(to bottom, #e74a29 0%, #e6451b 50%, #d02e17 50%, #b3150b 100%);
}

.button.red:before {
  background: #ee442c;
  background-image: -webkit-linear-gradient(top, #b32511, #f3533c);
  background-image: -moz-linear-gradient(top, #b32511, #f3533c);
  background-image: -o-linear-gradient(top, #b32511, #f3533c);
  background-image: linear-gradient(to bottom, #b32511, #f3533c);
}

.button.red:active {
  background: #e63b1b;
  background-image: -webkit-linear-gradient(top, #a9110b 0%, #de3819 60%, #e63b1b 100%);
  background-image: -moz-linear-gradient(top, #a9110b 0%, #de3819 60%, #e63b1b 100%);
  background-image: -o-linear-gradient(top, #a9110b 0%, #de3819 60%, #e63b1b 100%);
  background-image: linear-gradient(to bottom, #a9110b 0%, #de3819 60%, #e63b1b 100%);
}

.button.red:active:after {
  border-color: #e63b1b;
}

.column.blue {
  background: #4071b6;
}

</style>



// WEBPACK FOOTER //
// src/components/Main.vue